import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import SplashTemplate from 'shared/components/SplashTemplate'

class NotFound extends Component {
    render() {
        return (
            <SplashTemplate>
                <div>
                    <h1 className="spark-splash-screen__heading">404</h1>
                    <h3 className="spark-splash-screen__heading">Page you are looking for does not exist</h3>
                    <span>Return to <Link className="spark-splash-screen__heading_link" to={'/'}>home page</Link></span>
                </div>
            </SplashTemplate>
        )
    }
}

export default NotFound


// WEBPACK FOOTER //
// ./src/shared/components/ErrorPages/NotFound.js